import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { clearAnalyticsUser } from '../services/analyticsService';
import { getStoredUser, hasAdminAccess } from '../utils/authUser';
import LanguageToggle from './LanguageToggle';
import LandingNavIcon from './LandingNavIcon';
import { FleetLandingHeader, FleetLandingDock } from './FleetLandingNavigation';

export default function FleetGiovanniNavigation() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [accountOpen, setAccountOpen] = useState(false);
  const user = getStoredUser();
  const signedIn = Boolean(user?.token);
  const labels = language === 'es'
    ? { about: 'Acerca de', guides: 'Guías', contact: 'Contacto', search: 'Buscar', chat: 'Chat', journal: 'Noticias', reviews: 'Reseñas', account: 'Cuenta', login: 'Entrar', logout: 'Salir' }
    : { account: 'Account', login: 'Sign in', logout: 'Sign out' };
  const logOut = () => {
    clearAnalyticsUser();
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    window.location.assign('/');
  };
  return <>
    <FleetLandingHeader isDarkMode labels={labels} brand={<Link className="gt-brand" to="/" aria-label="HOUSEITGOING home"><span className="gt-brand-mark">HIG</span><span><strong>HOUSEITGOING</strong><small>Giovanni Triana · Broker</small></span></Link>} headerExtra={<LanguageToggle compact />} onAbout={() => navigate('/about-us')} onGuides={() => navigate('/guides')} onContact={() => navigate('/contact-us')} />
    <FleetLandingDock isDarkMode labels={labels} onSearch={() => navigate('/search')} onChat={() => navigate('/chat')} onJournal={() => navigate('/blogs')} onReviews={() => navigate('/reviews')} onCloseAccount={() => setAccountOpen(false)} isAdmin={hasAdminAccess(user)} onAdmin={() => navigate('/admin')}>
      <div className="signin-dropdown">
        <button type="button" className="fleet-dock-button signin-toggle" onClick={() => signedIn ? setAccountOpen(!accountOpen) : navigate('/chat?login=1')} aria-expanded={signedIn ? accountOpen : undefined} aria-haspopup={signedIn ? 'dialog' : undefined}><LandingNavIcon name="account" /><span>{signedIn ? labels.account : labels.login}</span></button>
        {signedIn && accountOpen && <div className="signin-dropdown-content" role="dialog" aria-label={labels.account}><strong>{user.name || user.username}</strong><button type="button" className="toggle-form-btn" onClick={logOut}>{labels.logout}</button></div>}
      </div>
    </FleetLandingDock>
  </>;
}
